import { ChatNotificationsProvider } from '@/components/messaging/ChatNotificationsProvider';
import { MessagesSection } from '@/components/messaging/MessagesSection';

export function RestaurantMessagesPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-6">
      <ChatNotificationsProvider />
      <MessagesSection basePath="/restaurant/messages" />
    </div>
  );
}
